window.RakutenGtm = ({
    signUp: {
        success: function () {
            window.dataLayer.push({
                event: RakutenConstants.gtm.event.signUpResult,
                result: RakutenConstants.gtm.result.success
            });
        },
        failure: function (code) {
            window.dataLayer.push({
                event: RakutenConstants.gtm.event.signUpResult,
                result: RakutenConstants.gtm.result.error,
                errorMessage: RakutenConstants.gtm.result.errorResult + ' ' + code
            });
        }
    }
});
